import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
function Hero() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <section
      style={{
        width: "100%",
        backgroundColor: "#ededed",
        padding: isMobile
          ? "9.25rem 5% 2rem"
          : "10.5rem 1.25rem 0",
      }}
    >

      {/* CONTENT */}
      <div
        style={{
          maxWidth: "81.25rem", // 1300px
          width: "100%",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: isMobile
              ? "60px"
              : "clamp(3.5rem, 7vw, 6.5rem)",
            lineHeight: "1.05",
            margin: 0,
            letterSpacing: "-0.05em",
            color: "#000000",
            fontFamily:isMobile ? "ZTNatureMed" : "ZTNatureSemiB"
          }}
        >
          AI Visual Direction.
        </h1>

        <h1
          style={{
            fontSize: isMobile
              ? "60px"
              : "clamp(3rem, 6vw, 6.5rem)",
            lineHeight: "1.05",
            margin: 0,
            color: "rgba(50, 46, 49, 0.38)",
            letterSpacing: "-0.03em",
            fontFamily:isMobile ? "ZTNatureMed" : "ZTNatureSemiB"
          }}
        >
          Using{" "}
          <span
            style={{
              fontFamily: "HenriettaSemiBI",
              color: "rgba(50, 46, 49, 0.38)",
              letterSpacing: "-0.03em",
            }}
          >
            References.
          </span>
        </h1>

        <p
          style={{
            margin: "1.75rem auto 0",
            maxWidth: isMobile ? "90%" : "37rem",
            fontSize: isMobile ? "1rem" : "1.125rem",
            lineHeight: "1.6",
            color: "rgba(0,0,0,0.4)",
            fontFamily: "DelightReg", 
          }}
        >
          The largest database of reference images across advertising and cinema.
        </p>
        <p
          style={{
            margin: "0 auto 0",
            maxWidth: isMobile ? "60%" : "35rem",
            fontSize: isMobile ? "1rem" : "1.125rem",
            lineHeight: "1.6",
            color: "rgba(0,0,0,0.4)",
            fontFamily: "DelightReg", 
          }}
        >
          Brands use rushcut to stay creatively in-sync.
        </p>

        {/* CTA BUTTONS */}
        <div
          style={{
            marginTop: "2.75rem",
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            flexWrap: "wrap",
          }}
        >
          <button
            style={{
              backgroundColor: "#322E31",
              color: "#ededed",
              border: "none",
              borderRadius: "16px",
              padding: isMobile
                ? "0.3rem 2rem"
                : "0.3rem 3rem",
              fontSize: isMobile ? "0.95rem" : "1.325rem",
              fontWeight: "600",
              cursor: "pointer",
              fontFamily: "DelightMed",
              zIndex:10,
            }}
            onClick={() => navigate("/lets-talk")}
          >
            Talk to us
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
